import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

interface SortableVirtualItemProps {
  id: string | number;
  children: React.ReactNode;
  disabled?: boolean;
  style?: React.CSSProperties;
}

const SortableVirtualItem: React.FC<SortableVirtualItemProps> = ({
  id,
  children,
  disabled = false,
  style = {},
}) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
    disabled,
  });

  const sortableStyle: React.CSSProperties = {
    ...style,
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={sortableStyle} {...attributes}>
      {React.cloneElement(children as React.ReactElement, {
        dragHandleProps: disabled ? {} : listeners,
        isDragging,
      })}
    </div>
  );
};

export default SortableVirtualItem;
